export const mapSavedSearchToGraph = savedSearch => {
    const connections = { connectionType: savedSearch.connections.connectionType };

    const space = {
        density: savedSearch.space.density,
        purpose: savedSearch.space.purpose,
        size: savedSearch.space.size,
        typeOfCenter: savedSearch.space.typeOfCenter,
        typeOfFacility: savedSearch.space.typeOfFacility,
    };

    const tenants = {
        density: savedSearch.tenants.density,
        purpose: savedSearch.tenants.purpose,
        size: savedSearch.tenants.size,
        typeOfCenter: savedSearch.tenants.typeOfCenter,
        typeOfFacility: savedSearch.tenants.typeOfFacility,
    };

    const products = {
        areYou: savedSearch.products.areYou,
        productTypes: savedSearch.products.productTypes,
    };

    return { ...savedSearch, connections, products, tenants, space };
};
